import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import "./Offers.scss";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx'
import { Button } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact.jsx";
import {
  FaBath,
  FaBed,
  FaChair,
  FaMapMarkerAlt,
  FaParking,
  FaShare,
} from "react-icons/fa";
const CountyTest = () => {
  const auth = getAuth();

  const [listings, setListings] = useState(null);
  const [listing, setListing] = useState(null);
  const [shareLinkCopied, setShareLinkCopied] = useState(false);
  const [contactLandlord, setContactLandlord] = useState(false);
  const [lastFetchedListing, setLastFetchListing] = useState(null);
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [clickedSuggestion, setClickedSuggestion] = useState("");


  const [fmrData, setFmrData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch FMR data
  const fetchFmrData = async () => {
    const apiKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiNDAwODEyNWExOGQ4NGFhMzlmMThlNzY1NDNjYTQxYzVkMDJkZDg3ZGYwNjAyNTYwNTViNWJlMTk1ZmI5ZTIxNzZhNzkwNzViYWRmMGE0YWUiLCJpYXQiOjE3MzU1OTc4NTIuODMzMjk1LCJuYmYiOjE3MzU1OTc4NTIuODMzMjk4LCJleHAiOjIwNTExMzA2NTIuODI4OTA2LCJzdWIiOiI4NDkyNyIsInNjb3BlcyI6W119.F1QN3CJA-QThQP6ddHpsT1HMEv3HKHApwW_ABUaFBg_Mg-kNIGBCXk-TW4UlvVIR4vX03WOLkl0hSqc3uSb1EQ';  // Replace with your actual API key
    const baseUrl = 'https://www.huduser.gov/hudapi/public/fmr'
    const year = 2023;  // Replace with the desired year
    const state = 'CA';  // Replace with the desired state abbreviation
    const county = 'Los Angeles';  // Replace with the desired county
    
    try {
      // Construct the full URL with query parameters
      // const url = `${baseUrl}?year=${year}&state=${state}&county=${county}&api_key=${apiKey}`;
      // const url = 'https://www.huduser.gov/hudapi/public/fmr/listStates'
      const newUrl = `https://www.huduser.gov/hudapi/public/fmr/statedata/TN?year=2024?access_token=${apiKey}`
      const bearer = `?access_token=${apiKey}`
      // Make the API request
      const response = await fetch(newUrl);

      // Check for a successful response
      if (!response.ok) {
        throw new Error('Failed to fetch FMR data');
      }

      // Parse the JSON response
      const data = await response.json();
      setFmrData(data);  // Set data to state
    } catch (err) {
      setError(err.message);  // Handle errors
    } finally {
      setLoading(false);  // Set loading to false after the request is complete
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchFmrData();
  }, []);

  // Render loading, error, or the FMR data
  if (loading) {
    return <div>Loading FMR data...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }




  return (
    <div className="offer" >
      <h1 className="offer__title">Property Lookup</h1>
      {/* <OpenModalButton/> */}

      <div style={{ display: "flex", height: "100vh"}}>
      <Sidebar style={{ backgroundColor: 'white '}}>
        <Menu style={{ backgroundColor: 'white'}}>
          <MenuItem >
          <div style={{marginLeft:-43}}>
          <img
            src="https://i.ibb.co/s2dBvDt/elevate.png"
            alt="logo"
            
            width={300}
          ></img>
          </div>
          </MenuItem>
          
          <SubMenu label="Deal Finder" icon={<HolidayVillageIcon />}>
            <MenuItem icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
            <MenuItem icon={<PieChartIcon />}>City Research</MenuItem>
            <MenuItem icon={<SearchIcon />}>Property Lookup</MenuItem>
            <MenuItem icon={<CalculateIcon />}>Deal Calculator</MenuItem>
            <MenuItem icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
          </SubMenu>
          <SubMenu label="              Real Estate Courses" icon={<SchoolIcon />}>
            <MenuItem icon={<AccountBalanceRoundedIcon />}>
              Elevate with Section Eight
            </MenuItem>
          </SubMenu>
          {/* <MenuItem icon={<GroupIcon />}>Tenant Finder</MenuItem> */}
          <SubMenu label="Tenant Hub" style={{ backgroundColor: 'white'}} icon={<GroupIcon />}>
            <MenuItem icon={<HouseIcon />}> Housing Authority DIrectory </MenuItem>
            <MenuItem icon={<EmojiPeopleIcon />}> Tenant Lookup </MenuItem>
           
          </SubMenu>
          
          <SubMenu label="Title Hub" style={{ backgroundColor: 'white'}} icon={<ReceiptLongIcon />}>
            <MenuItem icon={<NoteAddIcon />}> Title Setup </MenuItem>
            
            
           
          </SubMenu>
          <SubMenu label="Legal Hub" style={{ backgroundColor: 'white'}} icon={<GavelIcon />}>
            <MenuItem icon={<LocalPoliceIcon />}> Legal Services</MenuItem>
            
            
           
          </SubMenu>
          <SubMenu label="Insurance Hub" style={{ backgroundColor: 'white'}} icon={<GppGoodIcon />}>
            
            <MenuItem icon={<SupportIcon />}> Landlord Insurance </MenuItem>
            <MenuItem icon={<CottageIcon />}> Home Warrenties </MenuItem>
            
           
          </SubMenu>
          <SubMenu label="Business Setup" style={{ backgroundColor: 'white'}} icon={<BusinessIcon />}>
            
            <MenuItem icon={<AddIcon />}> Form Entity </MenuItem>
            <MenuItem icon={<RequestQuoteIcon />}> Taxes </MenuItem>
            <MenuItem icon={<CreditScoreIcon />}> Build Credit </MenuItem>
            <MenuItem icon={<LockIcon />}> Asset Protection </MenuItem>
            <MenuItem icon={<AttachMoneyIcon />}> Business Funding </MenuItem>
            
           
          </SubMenu>
          <SubMenu label="Elevate Financial" style={{ backgroundColor: 'white'}} icon={<PaidIcon />}>
            <MenuItem icon={<CurrencyExchangeIcon />}> Loan Portal </MenuItem>
            <MenuItem icon={<SpeedIcon />}> Credit Tradelines </MenuItem>
            
           
          </SubMenu>
          <SubMenu label="Settings" style={{ backgroundColor: 'white'}} icon={<SettingsSuggestIcon />}>
            <MenuItem icon={<AccountCircleRoundedIcon />}> Account </MenuItem>
            {/* <MenuItem icon={<ShieldRoundedIcon />}> <OpenModalButton/> </MenuItem> */}
            <MenuItem icon={<NotificationsRoundedIcon />}>
              Notifications
            </MenuItem>
          </SubMenu>
          <MenuItem icon={<LogoutRoundedIcon />}> Logout </MenuItem>
        </Menu>
      </Sidebar>
      <div className="w-72">
    </div>
      
        <>
          <main>
          <div>
      <h1>FMR Data</h1>
      {fmrData ? (
        <pre>{JSON.stringify(fmrData, null, 2)}</pre>
      ) : (
        <div>No FMR data available</div>
      )}
    </div>
          
           
          </main>
          
        </>
     
    </div>
    </div>
  );
};

export default CountyTest;


const styles = {
  container: {
    margin: '20px auto',
    maxWidth: '600px',
    fontFamily: 'Arial, sans-serif',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width:'50%',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  listItemHover: {
    backgroundColor: '#f7f7f7',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
};
